export default (conversation, myId) => conversation.users.find((user) => user.id !== myId);
